import { Dialog } from 'primereact/dialog';

const CoberturaDialog = ({ visible, onHide }) => {
    return (
        <Dialog 
            header="Detalles de Cobertura" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
        >
            <div className="grid">
                <div className="col-12 md:col-4">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Enero</div>
                        <div className="text-4xl text-blue-500 font-bold">1%</div>
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Diciembre</div>
                        <div className="text-4xl text-orange-500 font-bold">2%</div>
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Noviembre</div>
                        <div className="text-4xl text-green-500 font-bold">2%</div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default CoberturaDialog;